import { createInteractiveColorVars } from '../../helpers/createInteractiveColorVars/index.js';

const PrimaryColors = createInteractiveColorVars('primary', true);
const PrimaryColorsLightValues = Object.freeze({
    base: {
        default: '#C209C1',
        action: '#920792',
        active: '#C209C1',
        activeAction: '#920792',
    },
    text: {
        default: '#ffffff',
        action: '#ffffff',
        active: '#ffffff',
        activeAction: '#ffffff',
    },
    alpha: {
        alpha20: '#C209C133',
        alpha50: '#C209C17F',
        alpha80: '#C209C1CC',
    },
});
const PrimaryColorsDarkValues = Object.freeze({
    base: {
        default: '#E859B4',
        action: '#9E3D7A',
        active: '#E859B4',
        activeAction: '#9E3D7A',
    },
    text: {
        default: '#000000',
        action: '#000000',
        active: '#000000',
        activeAction: '#000000',
    },
    alpha: {
        alpha20: '#E859B433',
        alpha50: '#E859B47F',
        alpha80: '#E859B4CC',
    },
});

export { PrimaryColors, PrimaryColorsDarkValues, PrimaryColorsLightValues };
